// @flow
import React from "react"
import type { DateRangeMoment, DateString } from "data/units/date/types"
import type { ProductVariantAvailableAffiliate } from "data/product/types"
import { formatMoney } from "data/units/money/formatters"
import { getDaysApart, dateStringFromMoment } from "data/units/date/helpers"
import { DayPriceWrap } from "./styled"
import { getPriceForDay } from "./helpers"

type Props = {|
  day: DateString,
  value: DateRangeMoment,
  variantAffiliate?: ProductVariantAvailableAffiliate,
|}

const DayPrice = ({ handleChange, day, value, variantAffiliate }: Props) => {
  if (!value || !value.startDate) return null

  const daysFromStart = getDaysApart(day, dateStringFromMoment(value.startDate))
  const price = getPriceForDay(variantAffiliate, daysFromStart)
  const currency = variantAffiliate
    ? variantAffiliate.location.country.currency
    : "USD"
  if (!price) return null
  return (
    <DayPriceWrap>
      {day === value.startDate ? "" : "+"}
      {formatMoney(price, false, currency)}
    </DayPriceWrap>
  )
}

export default DayPrice



// WEBPACK FOOTER //
// ./src/components/Calendar/Month/Day/DayPrice/index.js